import React, { useState } from 'react';
import './ProcessTemplatesContent.css';
import TemplatesData from "../Data/Templates.json";
import ProcessData from "../Data/processData.json";
import mailData from "../Data/mailData.js";

function ProcessTemplates() {
  const [displayTab, setDisplayTab] = useState("process");
  const [onTdClick, setOnTdClick] = useState(false);
  const [expand, setExpand] = useState(-1);
  const [tdesc, setTdesc] = useState("0");

  //   const toggleReadMore = () => {
  //     setIsReadMore(!isReadMore);
  //   };

  const tempDesc = (sNo) => {
    setTdesc(sNo);
  }

  const toggleTableData = () => {
    setOnTdClick(!onTdClick);

  };

  const toggleReadMore = (id) => {
    if (expand === id) {
      setExpand(-1)

    } else {
      setExpand(id)

    }

  };
  return (
    <>
      <div className="main-banner">
        <img src={process.env.PUBLIC_URL + "/images/ProcessTemplates/ProcessTemplatesBanner.png"} alt="Banner" className="banner-img" />
        <div className="banner-content">
          <h1>Process and Templates</h1>
          {/* <p><i>Lorem ipsum is simply dummy text of the printing</i></p> */}
        </div>
      </div>
      <div className='process_main_div'>
        <h2>Process and Templates</h2>
        <div className='process_button_div'>
          <a className={displayTab === "process" ? 'tab-active' : 'tab-inactive'} onClick={() => setDisplayTab('process')} >Process</a>
          <a className={displayTab === "templates" ? 'tab-active' : 'tab-inactive'} onClick={() => { setDisplayTab('templates') }} >Templates</a>
        </div>
        {
          displayTab === "process" ?
            <div className="process_content">
              {/* <h3>Process</h3> */}
              <div className='process_mid_sec'>
                <div className='process_mid_img_sec'>
                  <img src={process.env.PUBLIC_URL + "/images/ProcessTemplates/process1stimg.png"} alt="process" className='responsiveImg' />
                </div>
                <div className='process_mid_text_sec'>
                  <h3>Scope and Activity</h3>
                  <p>The L&TT process document describes the processes that are implemented within all learning tracks to ensure quality of their products throughout their life-cycle. L&TT delivers training needs to all the employees at ATCI, starting from fresh college graduates to senior leadership. L&TT delivers learning needs to the employees based at all ATC centers in India.</p>
                  <p>The purpose of the process document is to define the processes of L&TT at ATCI, outline
                    the organizational structure within L&TT and define the roles & responsibilities within
                    L&TT.</p>
                  <p>L&TT follows the global training policy (1151) as documented on the Accenture
                    learning portal (myLearning) for reference and use.</p>
                  <p>L&TT works with the market Learning MDs who are the single-point-of-contact for L&TT in
                    each market and practice to identify and assess the learning needs.</p>
                  <p><a className="download_button" target="_blank"
                    href={process.env.PUBLIC_URL + "/images/L&TT Process Document_v2.9.pdf#toolbar=0"} rel="noreferrer">
                    Click here to see the process document
                  </a></p>
                </div>

              </div>
              <div className='process_hr'>
                <hr />
              </div>
              <div className="process_mid_subsection">
                <h3 className="subprocess_header">Next level of process within L&TT as applied to
                  tracks and functions.</h3>
                <div className='process_subprocess_content'>
                  <div className='process_subprocess_wrapper'>
                    {ProcessData.map((item, i) => {
                      let text = item.content.split(' ');
                      let text2 = text.splice(0, 19).join(" ");
                      return (
                        <>
                          <div className='process_subprocess_box'>
                            <img src={item.img} alt="process" className='responsiveImg' />
                            <div className='process_subprocess_box_text'>
                              <h4>{item.header}</h4>
                              <p className='process_subprocess_para'>
                                {expand === i ? item.content : text2 + "..."}
                              </p>
                              <p onClick={() => toggleReadMore(item.id)} className="read-or-hide">
                                {expand === i ? " Show less" : (item.content.split(' ').length > 19 ? "Read more" : "")}
                              </p>
                              {item.file !== "" ? <a className="download_button" target="_blank"
                                href={process.env.PUBLIC_URL + `/images/${item.file}.pdf#toolbar=0`} rel="noreferrer">
                                Know more
                              </a> : null}
                              {/* {item.file !== '' ?
                               <a className="download_button" target="_blank" 
                                href={process.env.PUBLIC_URL + `/images/${item.file}.pdf#toolbar=0`}>
                                Know More
                              </a>
                              :
                              <a className="download_button">
                                Know More
                              </a>} */}
                              {/* <a className="download_button" href={require(`../Data/process-and-templates/${item.file}`)}>
                                   Know More
                                 </a>                                  */}
                            </div>
                          </div>
                        </>
                      )
                    })}

                  </div>
                </div>
              </div>
            </div> : ""
        }
        {
          displayTab === "templates" ?
            <div className="template_content">
              <p className='template_content_para'>The below standard templates have to be used by L&TT champions to
                update the data based on the set frequency and upload them under artifacts.</p>
              <table className="template_table">
                <tr>
                  <th>SL.#</th>
                  <th className='template_th'>Templates</th>
                  <th>Frequency of upload</th>
                  <th></th>
                </tr>

                {TemplatesData.map((item) => {
                  return (
                    <tr>
                      <td>{item.SlNo}</td>
                      <td className='template_td'>
                        <p className="template_td_para" onClick={() => { tempDesc(item.SlNo); toggleTableData(); }}>{item.Templates}</p>
                        {tdesc === item.SlNo ?
                          <p className='template_p'>{item.content}</p> : ""
                        }

                      </td>
                      <td className='template_frequency'>{item.Frequency}</td>
                      <td>
                        <a className="download_button" href={require(`../Data/process-and-templates/${item.file}`)}>
                          Download
                        </a>
                      </td>
                    </tr>
                  )
                })}
              </table>
            </div>

            : ""
        }
      </div>
      <div className="icons-container">
        <div className="icons-wrap">

          <div className="icons-row row1">
            <div className="icons-box">
              <div className="img-link">
                <img src={process.env.PUBLIC_URL + "/images/Home/contact_icon.png"} alt="Mailicon" className="group-img mailIcon" id="icon-chat" />
                <a className="contact-us" target='_blank' href={`mailto:${mailData.dellearningframework}`} rel="noreferrer"><span className='menu-text'>Write to us</span></a>
                {/* <span className="contact-word">Mail</span> */}
              </div>
            </div>
          </div>

        </div>
      </div>
      <div className='link_container_below'>
        <div className='link_cont_wrap'>
          <div>
            <img src={process.env.PUBLIC_URL + "/images/Home/Acc_GT_Dimensional_RGB.png"} alt="AccentureIcon" className='link_accenture_logo' />
          </div>
          <div className='link_text_cont'>
            <span>For any queries or support, you may reach out to
              <a className="link_anchor" href={`mailto:${mailData.qualityassurance}`} target="_blank" rel="noreferrer"> {mailData.qualityassurance} </a></span>
          </div>
        </div>
      </div>
    </>
  )
}

export default ProcessTemplates;